import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import mandateModalStyles from "./LoanMandateModal.module.css";
import { toast } from "react-toastify";
import { BiFileBlank } from "react-icons/bi";
import { TbFileUpload, TbRefresh, TbFileDownload } from "react-icons/tb";
import axios from "axios";
import { url } from "../../../../../../App";
import {
  TextField,
  MenuItem,
  Box,
  Autocomplete,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useBorrowerContext } from "../../../store/borrower-details";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";
import styles from "../../../BorrowerDetails.module.css";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { Edit, Info, Send } from "@mui/icons-material";

const downloadHandler = (url) => {
  const downloadLink = document.createElement("a");
  const linkSource = `data:application/pdf;base64,${url}`;
  const fileName = `Blank form.pdf`;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "8px",
};

const LoanMandateModal = ({
  closeModal,
  loanDetails = {},
  openLoader,
  closeLoader,
  isDisbursed,
}) => {
  const EMAIL = Cookies.get("Email");
  const TOKEN = Cookies.get("Token");
  const UNIQUE_ID = localStorage.getItem("uniqueID");
  const { updateBorrowerData } = useBorrowerContext();
  const Navigate = useNavigate();
  const loan_mandate = loanDetails?.data?.loan_mandate;
  const loanSchedule = loanDetails?.data.loan_schedule;
  const { loan_id: loanId } = loanDetails.data;
  const [loanMandate, setLoanMandate] = useState([]);
  const [loanScheduleData, setLoanScheduleData] = useState([]);
  const [showLink, setShowLink] = useState(false);
  const [textboxVal, setTextboxVal] = useState({
    mandateId: "",
    umrnId: "",
  });
  const [enachVal, setEnachVal] = useState({
    value: "",
  });
  const [enachFrequency, setEnachFrequency] = useState("");
  const [enachVisible, setEnachVisible] = useState(false);
  const [visible, setvisible] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [loading, setLoading] = useState(false);
  const collection_bank = {
    collection_bank_account_number:
      loanDetails.data.collection_bank_account_number || "",
    collection_bank_branch: loanDetails.data.collection_bank_branch || "",
    collection_bank_ifsc: loanDetails.data.collection_bank_ifsc || "",
    collection_bank_name: loanDetails.data.collection_bank_name || "",
    collection_bank_type: loanDetails.data.collection_bank_type || "",
    collection_beneficiary_name:
      loanDetails.data.collection_beneficiary_name || "",
    ifsc_prefix: loanDetails.data.collection_bank_ifsc
      ? loanDetails.data.collection_bank_ifsc.slice(0, 4)
      : "",
    mandate_customer_Name: loanDetails.data.mandate_customer_name || "",
  };
  const [bankPayload, setBankPayload] = useState({
    destination_bank_name: "",
    destination_bank_id: "",
  });
  const [activatedUmrn, setActivatedUmrn] = useState(null);
  const [isMandateToggled, setIsMandateToggled] = useState(false);
  const [selectedMandate, setSelectedMandate] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [custBankName, setCustBankName] = useState("");
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editedName, setEditedName] = useState("");
  const [updatedCustomerName, setUpdatedCustomerName] = useState(""); // Holds saved value

  const currentDisplayValue =
    collection_bank?.mandate_customer_Name ||
    updatedCustomerName ||
    custBankName ||
    "N/A";

  const handleOpenModal = () => {
    setEditedName(currentDisplayValue === "N/A" ? "" : currentDisplayValue);
    setOpenEditModal(true);
  };

  const handleSaveModal = async () => {
    openLoader();
    try {
      const payload = {
        token: TOKEN,
        email: EMAIL,
        loan_id: loanId,
        mandate_customer_name: editedName,
        borrower_uniqueno: UNIQUE_ID,
        loanproduct_id: loanDetails?.data?.loanproduct_id
      };

      const res = await axios.post(url + "/loan/updatenew", payload);

      if (res.data?.auth) {
        setUpdatedCustomerName(editedName);
        setOpenEditModal(false);
        toast.success(res.data.message || "Name updated successfully");
      } else {
        toast.error(res.data?.message || "Failed to update name");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Error updating name");
    } finally {
      closeLoader();
    }
  };

  console.log(activatedUmrn)

  useEffect(() => {
    const fetchBankDetails = async () => {
      const ifsc = collection_bank.collection_bank_ifsc;
      const acNo = collection_bank.collection_bank_account_number;

      if (!ifsc || !acNo) return;

      try {
        const checkStatus = await axios.post(`${url}/loan/fetchBankDetails`, {
          email: EMAIL,
          token: TOKEN,
          custId: loanId,
          bankIfsc: ifsc,
          acNo: acNo,
        });

        if (checkStatus?.data?.message?.accHolderName) {
          setCustBankName(checkStatus.data.message.accHolderName);
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
      }
    };

    fetchBankDetails();
  }, [
    EMAIL,
    TOKEN,
    loanId,
    collection_bank.collection_bank_ifsc,
    collection_bank.collection_bank_account_number,
  ]);

  const handleOpenDetails = (e, mandate) => {
    console.log(mandate)
    e.stopPropagation();
    setSelectedMandate(mandate);
    setOpenModal(true);
  };

  const handleCloseDetails = () => {
    setSelectedMandate(null);
    setOpenModal(false);
  };

  const formatDateTime = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  useEffect(() => {
    if (loan_mandate && loan_mandate.length > 0) {
      const sorted = [...loan_mandate].sort(
        (a, b) => new Date(b.updated_date || 0) - new Date(a.updated_date || 0)
      );
      setLoanMandate(sorted);
    }
  }, [loan_mandate]);

  useEffect(() => {
    if (EMAIL === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: TOKEN,
          email: EMAIL,
          useremail: EMAIL,
        })
        .then((res) => {
          // console.log(res);
          setEnachVisible(res.data[0].permission.Initiate_enach_loan);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [EMAIL, TOKEN]);

  const textboxValueHandler = (field) => {
    return (e) => {
      setTextboxVal((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    };
  };

  const getMandates = async (mandate_id) => {
    // console.log(mandate_id)
    openLoader();
    try {
      const request = {
        token: TOKEN,
        email: EMAIL,
        mandate_id: mandate_id,
        loan_id: loanId,
      };
      const { data: response } = await axios.post(
        `${url}/loan/getMandateData`,
        request
      );
      // console.log(response,"response");
      if (!response.auth) {
        toast.error(response.message);
        return;
      }
      const refreshLoans = await axios.post(
        url + "/borrower/borrowertoalldetails",
        {
          token: TOKEN,
          email: EMAIL,
          borrower_uniqueno: UNIQUE_ID,
        }
      );
      updateBorrowerData((prevState) => ({
        ...prevState,
        loan: refreshLoans.data.message.loan,
      }));
      const refreshedLoans = refreshLoans.data.message.loan;
      const newMandate = refreshedLoans.filter((loan) => {
        return loan.loan_id === loanId;
      });
      // console.log(newMandate);
      const sorted = [...newMandate.loan_mandate].sort(
        (a, b) => new Date(b.updated_date || 0) - new Date(a.updated_date || 0)
      );
      setLoanMandate(sorted);
      toast.success(response.message);
    } catch (err) {
      console.log(err);
      toast.error(
        err.response.data.message ||
        "Error while fetching mandate from console."
      );
    } finally {
      closeLoader();
    }
  };

  const getMandate = async (mandate_id, auth_mode) => {
    // console.log(mandate_id);
    // console.log(auth_mode);
    openLoader();
    try {
      const endpoint = auth_mode === "upi" ? "/getmandate/upi" : "/getmandate";
      const request = {
        token: TOKEN,
        email: EMAIL,
        mandate_id: mandate_id,
        loan_id: loanId,
        borrower_uniqueno: UNIQUE_ID,
      };
      const { data: response } = await axios.post(
        `${url}/loan${endpoint}`,
        request
      );
      // console.log(response);
      if (!response.auth) {
        toast.error(response.message);
        if (response.logout) {
          return Navigate("/");
        }
        return;
      }
      const refreshLoans = await axios.post(
        url + "/borrower/borrowertoalldetails",
        {
          token: TOKEN,
          email: EMAIL,
          borrower_uniqueno: UNIQUE_ID,
        }
      );
      updateBorrowerData((prevState) => ({
        ...prevState,
        loan: refreshLoans.data.message.loan,
      }));
      const refreshedLoans = refreshLoans.data.message.loan;
      const newMandate = refreshedLoans.filter((loan) => {
        return loan.loan_id === loanId;
      });
      // console.log(newMandate);
      const sorted = [...newMandate.loan_mandate].sort(
        (a, b) => new Date(b.updated_date || 0) - new Date(a.updated_date || 0)
      );
      setLoanMandate(sorted);
      toast.success(response.message);
    } catch (err) {
      console.log(err);
    } finally {
      closeLoader();
    }
  };

  const getPresentation = async (umrnId) => {
    try {
      const request = {
        token: TOKEN,
        email: EMAIL,
        umrn: umrnId,
        loan_id: loanId,
      };

      const { data: response } = await axios.post(
        `${url}/loan/getpresentation`,
        request
      );
      // console.log(request, response);
      if (!response.auth) {
        toast.error(response.message);
        if (response.logout) {
          return Navigate("/");
        }
        return;
      }
      const refreshLoans = await axios.post(
        url + "/borrower/borrowertoalldetails",
        {
          token: TOKEN,
          email: EMAIL,
          borrower_uniqueno: UNIQUE_ID,
        }
      );
      updateBorrowerData((prevState) => ({
        ...prevState,
        loan: refreshLoans.data.message.loan,
      }));
      setLoanScheduleData(loanSchedule);
      toast.success(response.message);
    } catch (err) {
      console.log(err);
      toast.error(err.message + "from console");
    }
  };

  const copyLinkHandler = async (link) => {
    const textArea = document.createElement("textarea");
    try {
      textArea.value = link;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      toast.success("Link Copied");
    } catch {
      toast.info(`Error copying the text, please copy the link manually`);
      setShowLink(true);
    }
  };

  // const scheduleTableHandler = (mandate) => {
  //   const data = loanSchedule?.filter((_) => _?.mandate_id === mandate);
  //   if (!data) {
  //     toast.error("No records found");
  //     return;
  //   }
  //   if (data?.length === 0) {
  //     toast.error("No records found");
  //     return;
  //   }
  //   setLoanScheduleData(data);
  // };

  const blankFormDownload = async (mandateId) => {
    try {
      const request = {
        token: TOKEN,
        email: EMAIL,
        loan_id: loanId,
        mandate_id: mandateId,
      };

      const { data: response } = await axios.post(
        url + "/loan/filledform",
        request
      );
      if (!response.auth) {
        toast.error(response.message);
        return;
      }
      downloadHandler(response.message);
    } catch (err) {
      console.log(err);
      toast.error(`${err.message} from console`);
      return;
    }
  };

  const uploadFilledForm = async (e, mandateId) => {
    try {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async (eve) => {
        const base64Data = eve.target.result.split(",").pop();
        const request = {
          token: TOKEN,
          email: EMAIL,
          loan_id: loanId,
          mandate_id: mandateId,
          file_data: base64Data,
        };
        const { data: response } = await axios.post(
          url + "/loan/uploadform",
          request
        );
        if (!response.auth) {
          toast.error(response.message);
        }
        toast.success(response.message);
      };
    } catch (err) {
      console.log(err);
    }
  };

  const downloadPhysicalMandate = async (mandateId) => {
    try {
      const request = {
        token: TOKEN,
        email: EMAIL,
        borrower_uniqueno: UNIQUE_ID,
        loan_id: loanId,
        mandate_id: mandateId,
      };
      const { data: response } = await axios.post(
        url + "/loan/physical/mandate",
        request
      );
      if (!response.auth) {
        toast.error(response.message);
        return;
      }
      // downloadHandler(response.message);
      toast.success(response.message);
    } catch (err) {
      console.log(err);
    }
  };

  const createMandate = async () => {
    // console.log(enachVal.value);
    openLoader();
    const hasActive = loanMandate.some(
      (mandate) => mandate.lms_Mandate_Status === "Activate"
    );
    try {
      const enachReq = {
        token: TOKEN,
        email: EMAIL,
        borrower_uniqueno: UNIQUE_ID,
        loan_id: loanId,
        auth_mode: enachVal.value,
        notify_customer: "true",
        frequency: enachFrequency,
        lms_Mandate_Status: hasActive ? "Deactivate" : "Activate",
        mandate_customer_Name: updatedCustomerName,
        destination_bank_name: bankPayload.destination_bank_name,
        destination_bank_id: bankPayload.destination_bank_id,
      };

      const endpoint =
        enachVal.value === "upi" ? "/loan/nach/upi" : "/loan/nach";
      const enachRes = await axios.post(url + endpoint, enachReq);
      // console.log(enachRes,"enachRes");

      if (!enachRes.data.auth) {
        closeLoader();
        toast.error(enachRes.data.message);
        return;
      } else {
        closeLoader();
        toast.success(
          enachVal.value === "upi"
            ? "ENACH Initiated using UPI"
            : "ENACH Initiated"
        );
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } catch (err) {
      closeLoader();
      console.error(err);
      toast.error(err.message);
    }
  };

  const pushtoCMS = async (activatedUmrn) => {
    openLoader();
    try {
      const enachReq = {
        token: TOKEN,
        email: EMAIL,
        umrn: activatedUmrn,
        loan_id: loanId,
      };

      const enachRes = await axios.post(url + '/loan/cms-umrn-update', enachReq);

      if (!enachRes.data.auth) {
        closeLoader();
        toast.error(enachRes.data.message);
        return;
      } else {
        closeLoader();
        toast.success(enachRes.data.message);
      }
    } catch (err) {
      closeLoader();
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleChange = (mandate_id, event) => {
    const isChecked = event.target.checked;
    const newStatus = isChecked ? "Activate" : "Deactivate";

    const previousMandateState = [...loanMandate];

    const selectedMandate = loanMandate?.find(
      (mandate) => mandate.mandate_id === mandate_id
    );

    setLoanMandate((prevMandates) => {
      const updated = prevMandates.map((mandate) => {
        if (isChecked) {
          return {
            ...mandate,
            lms_Mandate_Status:
              mandate.mandate_id === mandate_id ? "Activate" : "Deactivate",
          };
        } else {
          return mandate.mandate_id === mandate_id
            ? { ...mandate, lms_Mandate_Status: "Deactivate" }
            : mandate;
        }
      });

      return [...updated].sort(
        (a, b) => new Date(b.updated_date || 0) - new Date(a.updated_date || 0)
      );
    });

    if (isChecked) {
      setActivatedUmrn(selectedMandate?.umrn);
    } else {
      setActivatedUmrn(null);
    }
    setIsMandateToggled(true);

    axios
      .post(url + "/loan/toggleMandateStatus", {
        token: TOKEN,
        email: EMAIL,
        loan_id: loanId,
        mandate_id: mandate_id,
        lms_Mandate_Status: newStatus,
      })
      .then((res) => {
        if (res.data.auth) {
          toast.success(res.data.message);
        } else {
          setLoanMandate(
            [...(previousMandateState || [])].sort(
              (a, b) =>
                new Date(b.updated_date || 0) - new Date(a.updated_date || 0)
            )
          );
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoanMandate(
          [...(previousMandateState || [])].sort(
            (a, b) =>
              new Date(b.updated_date || 0) - new Date(a.updated_date || 0)
          )
        );
        toast.error("Failed to update mandate status.");
      });
  };

  useEffect(() => {
    const fetchBanks = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          url + "/loan/get-banks-from-console",
          {
            token: TOKEN,
            email: EMAIL,
            ifsc_prefix: collection_bank.ifsc_prefix,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data?.auth && Array.isArray(response.data?.data?.data)) {
          setBankList(response.data.data.data);
          // setFilteredBanks(response.data.data.data);
        } else if (Array.isArray(response.data?.data)) {
          setBankList(response.data.data);
          // setFilteredBanks(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching bank list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanks();
  }, [EMAIL, TOKEN, collection_bank.ifsc_prefix]);

  useEffect(() => {
    setEnachFrequency("");
  }, [enachVal.value]);

  const handleBankChange = (event, newValue) => {
    setSelectedBank(newValue);

    if (newValue) {
      setBankPayload({
        destination_bank_name: newValue.name || "",
        destination_bank_id: newValue.id || "",
      });
    } else {
      setBankPayload({
        destination_bank_name: "",
        destination_bank_id: "",
      });
    }
  };

  return (
    <>
      <div className={mandateModalStyles.topBar}>
        <h2>Loan Mandate Details</h2>
        <CloseIcon
          onClick={closeModal}
          className={mandateModalStyles.CloseIcon}
        />
      </div>

      {/* {!isDisbursed && ( */}
      <div className={mandateModalStyles.sectionBox}>
        <h3 className={mandateModalStyles.sectionTitle}>Actions</h3>

        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12} md={6}>
            <Box sx={{ maxWidth: 510, margin: "20px 0" }}>
              <Autocomplete
                options={bankList}
                getOptionLabel={(option) => option.name || ""}
                value={selectedBank}
                onChange={handleBankChange}
                loading={loading}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    {...props}
                    sx={{
                      fontSize: "14px",
                      lineHeight: "1.4",
                      paddingTop: "10px !important",
                      paddingBottom: "10px !important",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {option.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Bank"
                    variant="outlined"
                    placeholder="Type to search bank..."
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        minHeight: "40px",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      },
                      "& .MuiInputBase-input": {
                        height: "auto",
                        fontSize: "15px",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Box>

            <div className={mandateModalStyles.actionRow}>
              <div className={styles.textArea}>
                <label style={{ fontSize: "12px" }}>
                  Enach Using <span style={{ color: "red" }}>*</span>
                </label>
                <TextField
                  size="small"
                  select
                  value={enachVal.value}
                  className={mandateModalStyles.modalSel}
                  variant="outlined"
                  onChange={(e) =>
                    setEnachVal((prev) => ({ ...prev, value: e.target.value }))
                  }
                >
                  <MenuItem value="api">API</MenuItem>
                  <MenuItem value="esign">Esign</MenuItem>
                  <MenuItem value="physical">Physical</MenuItem>
                  <MenuItem value="upi">UPI</MenuItem>
                </TextField>
              </div>

              <div className={styles.textArea}>
                <label style={{ fontSize: "12px" }}>
                  Frequency <span style={{ color: "red" }}>*</span>
                </label>
                <TextField
                  size="small"
                  select
                  value={enachFrequency}
                  className={mandateModalStyles.modalSel}
                  variant="outlined"
                  onChange={(e) => setEnachFrequency(e.target.value)}
                >
                  {enachVal.value === "upi"
                    ? [
                      <MenuItem key="1" value="ADHO">
                        Adhoc
                      </MenuItem>,
                      <MenuItem key="2" value="MNTH">
                        Monthly
                      </MenuItem>,
                    ]
                    : [
                      <MenuItem key="3" value="Adhoc">
                        Adhoc
                      </MenuItem>,
                      <MenuItem key="4" value="Monthly">
                        Monthly
                      </MenuItem>,
                      <MenuItem key="4" value="intraday">
                        Intraday
                      </MenuItem>,
                      <MenuItem key="4" value="daily">
                        Daily
                      </MenuItem>,
                    ]}
                </TextField>
              </div>

              {(enachVisible || visible) && (
                <button
                  className={mandateModalStyles.initiateBtn}
                  onClick={() => createMandate()}
                >
                  Initiate Enach
                </button>
              )}
            </div>

            <div className={styles.textArea}>
              <label style={{ fontSize: "12px" }}>Mandate ID</label>

              <div className={mandateModalStyles.inputRow}>
                <TextField
                  value={textboxVal.mandateId}
                  required
                  className={mandateModalStyles.modalsSel}
                  variant="outlined"
                  onChange={textboxValueHandler("mandateId")}
                  placeholder="Enter Mandate ID"
                  size="small"
                />
                <button onClick={() => getMandates(textboxVal.mandateId)}>
                  Fetch
                </button>
              </div>
            </div>

            <div className={styles.textArea}>
              <label style={{ fontSize: "12px" }}>Search UMRN</label>

              <div className={mandateModalStyles.inputRow}>
                <TextField
                  value={textboxVal.umrnId}
                  required
                  className={mandateModalStyles.modalsSel}
                  variant="outlined"
                  onChange={textboxValueHandler("umrnId")}
                  placeholder="Search UMRN"
                  size="small"
                />
                <button onClick={() => getPresentation(textboxVal.umrnId)}>
                  Search
                </button>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                padding: "16px",
              }}
            >
              <h4
                style={{
                  margin: "0 0 16px 0",
                  fontSize: "14px",
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                Collection Bank Details
              </h4>

              <Grid container spacing={2} sx={{ fontSize: "13px" }}>
                <Grid item xs={12} sm={6}>
                  <span
                    style={{
                      color: "#666",
                      fontWeight: "600",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Beneficiary Name:
                  </span>
                  <strong style={{ color: "#222" }}>
                    {collection_bank?.collection_beneficiary_name || "N/A"}
                  </strong>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <span
                    style={{
                      color: "#666",
                      fontWeight: "600",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Customer Name (Bank):
                  </span>
                  <strong style={{ color: "#222" }}>
                    {custBankName || collection_bank?.collection_beneficiary_name || "N/A"}
                  </strong>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <span
                      style={{
                        color: "#666",
                        fontWeight: "600",
                        display: "block",
                        marginBottom: "2px",
                      }}
                    >
                      Customer Name (Mandate):
                    </span>
                    <IconButton size="small" onClick={handleOpenModal} color="primary" title="Edit Name">
                      <Edit fontSize="small" />
                    </IconButton>
                  </div>
                  <strong style={{ color: "#222" }}>
                    {currentDisplayValue}
                  </strong>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <span
                    style={{
                      color: "#666",
                      fontWeight: "600",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Bank Name:
                  </span>
                  <strong style={{ color: "#222" }}>
                    {collection_bank?.collection_bank_name || "N/A"}
                  </strong>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <span
                    style={{
                      color: "#666",
                      fontWeight: "600",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Account Number:
                  </span>
                  <strong style={{ color: "#222" }}>
                    {collection_bank?.collection_bank_account_number || "N/A"}
                  </strong>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <span
                    style={{
                      color: "#666",
                      fontWeight: "600",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    IFSC Code:
                  </span>
                  <strong style={{ color: "#222" }}>
                    {collection_bank?.collection_bank_ifsc || "N/A"}
                  </strong>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <span
                    style={{
                      color: "#666",
                      fontWeight: "600",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Account Type:
                  </span>
                  <strong style={{ color: "#222" }}>
                    {collection_bank?.collection_bank_type || "N/A"}
                  </strong>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <span
                    style={{
                      color: "#666",
                      fontWeight: "600",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Branch:
                  </span>
                  <strong style={{ color: "#222" }}>
                    {collection_bank?.collection_bank_branch || "N/A"}
                  </strong>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>

      <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Edit Customer Name</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Customer Name"
            type="text"
            fullWidth
            variant="outlined"
            value={editedName}
            onChange={(e) => setEditedName(e.target.value)}
            size="small"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditModal(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleSaveModal} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <div className={mandateModalStyles.tabsWrapper}>
        <Tabs value={tabValue} onChange={(_, v) => setTabValue(v)}>
          <Tab label="Mandate Details" />
          {/* <Tab label="Presentation Details" /> */}
        </Tabs>

        {tabValue === 0 && (
          <div className={mandateModalStyles.tableSection}>
            <table className={mandateModalStyles.customTable}>
              <thead>
                <tr>
                  <th>Mandate ID</th>
                  <th>UMRN</th>
                  <th>Customer Status</th>
                  <th>Bank Status</th>
                  <th>Auth Mode</th>
                  {/* <th>Type</th> */}
                  <th>Frequency</th>
                  <th>Amount</th>
                  <th>Mandate Status</th>
                  <th>Mandate Link</th>
                  {/* <th>Nach Notify</th> */}
                  {/* <th>Fail Reason</th> */}
                  {/* <th>Created At</th>
                  <th>Updated At</th>
                  <th>Created By</th> */}
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loanMandate?.map((mandate, index) => (
                  <tr key={index}>
                    <td className={mandateModalStyles.mandateTd}>
                      <Tooltip title={mandate.mandate_id || ""} arrow>
                        <span>
                          {mandate.mandate_id?.length > 6
                            ? `${mandate.mandate_id.slice(0, 6)}...`
                            : mandate.mandate_id}
                        </span>
                      </Tooltip>

                      <ContentPasteIcon
                        onClick={() => copyLinkHandler(mandate.mandate_id)}
                        className={mandateModalStyles.copyIcon}
                        titleAccess="Copy Mandate ID"
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                      />
                    </td>
                    <td>{mandate.umrn}</td>
                    <td>{mandate.mandate_status}</td>
                    <td>{mandate.bank_status}</td>
                    <td>{mandate.auth_mode}</td>
                    {/* <td>{mandate.mandate_type}</td> */}
                    <td>{mandate.frequency}</td>
                    <td>{mandate.collection_amount}</td>
                    <td
                      className={
                        mandate.lms_Mandate_Status === "Activate"
                          ? mandateModalStyles.activeStatus
                          : mandateModalStyles.inactiveStatus
                      }
                    >
                      {mandate.lms_Mandate_Status}
                    </td>
                    {!showLink ? (
                      <td className={mandateModalStyles.copyLink}>
                        {mandate.loan_mandate_link ? (
                          <ContentPasteIcon
                            onClick={() => {
                              console.log(mandate);
                              copyLinkHandler(mandate.loan_mandate_link);
                            }}
                            className={mandateModalStyles.copyIcon}
                            titleAccess="Copy Mandate Link"
                          />
                        ) : (
                          "Link Not Found"
                        )}
                      </td>
                    ) : (
                      <td>{mandate.loan_mandate_link || "Link Not Found"}</td>
                    )}
                    {/*
                    <td>{mandate.nach_notify}</td>
                    <td>{mandate.failure_reason}</td>
                    <td>{formatDateTime(mandate?.created_date)}</td>
                    <td>{formatDateTime(mandate?.updated_date)}</td>
                    <td>{mandate.created_by}</td> */}
                    <td>
                      <div className={mandateModalStyles.actions}>
                        <Tooltip title="View Additional Details">
                          <IconButton
                            size="small"
                            onClick={(e) => handleOpenDetails(e, mandate)}
                            sx={{ color: "#1976d2" }}
                          >
                            <Info />
                          </IconButton>
                        </Tooltip>

                        {mandate.auth_mode === "physical" && (
                          <>
                            <BiFileBlank
                              cursor="pointer"
                              title="Store blank form"
                              onClick={() =>
                                blankFormDownload(mandate.mandate_id)
                              }
                            />

                            <input
                              type="file"
                              id={`file-${mandate.mandate_id}`}
                              style={{ display: "none" }}
                              onChange={(e) =>
                                uploadFilledForm(e, mandate.mandate_id)
                              }
                            />
                            <TbFileUpload
                              cursor="pointer"
                              title="Upload Form"
                              onClick={() =>
                                document
                                  .getElementById(`file-${mandate.mandate_id}`)
                                  .click()
                              }
                            />

                            <TbFileDownload
                              cursor="pointer"
                              title="Download Signed Mandate"
                              onClick={() =>
                                downloadPhysicalMandate(mandate.mandate_id)
                              }
                            />
                          </>
                        )}

                        <TbRefresh
                          cursor="pointer"
                          title="Refresh Mandate"
                          onClick={() =>
                            getMandate(mandate.mandate_id, mandate.auth_mode)
                          }
                        />

                        <Tooltip title="Activate / Deactivate">
                          <Switch
                            checked={mandate.lms_Mandate_Status === "Activate"}
                            onChange={(e) =>
                              handleChange(mandate.mandate_id, e)
                            }
                            sx={{
                              "& .MuiSwitch-switchBase.Mui-checked": {
                                color: "#0fa958", // thumb color when active
                              },
                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                              {
                                backgroundColor: "#0fa958", // track color when active
                              },

                              "& .MuiSwitch-switchBase": {
                                color: "#d9534f", // thumb color when inactive
                              },
                              "& .MuiSwitch-track": {
                                backgroundColor: "#d9534f", // track color when inactive
                              },
                            }}
                          />
                        </Tooltip>
                        {isDisbursed && (
                          // <Send
                          //   cursor="pointer"
                          //   title="Push To CMS"
                          //   onClick={() => pushtoCMS(activatedUmrn)}
                          //   disabled={!isMandateToggled}
                          // />
                          <Tooltip
                            title={
                              isMandateToggled
                                ? "Push To CMS"
                                : "Mandate must be toggle"
                            }
                          >
                            <span>
                              <IconButton
                                onClick={() => pushtoCMS(mandate.umrn)}
                                disabled={
                                  !isMandateToggled &&
                                  mandate.lms_Mandate_Status !== "Activate"
                                }
                                size="small"
                                sx={{
                                  color:
                                    isMandateToggled &&
                                      mandate.lms_Mandate_Status === "Activate"
                                      ? "#0fa958"
                                      : "action.disabled",
                                  "&.Mui-disabled": {
                                    color: "rgba(0, 0, 0, 0.26)",
                                  },
                                }}
                              >
                                <Send fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Modal
              open={openModal}
              onClose={handleCloseDetails}
              disableEnforceFocus
              style={{ zIndex: 1400 }}
            >
              <Box sx={modalBoxStyle}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={3}
                >
                  <Typography variant="h6" component="h2">
                    Additional Mandate Details
                  </Typography>
                  <IconButton onClick={handleCloseDetails} size="small">
                    <CloseIcon />
                  </IconButton>
                </Box>

                {selectedMandate && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      gap: "12px",
                      fontSize: "14px",
                    }}
                  >
                    {/* <div>
                      <strong>Type:</strong>{" "}
                      {selectedMandate.mandate_type || "N/A"}
                    </div> */}
                    <div>
                      <strong>Nach Notify:</strong>{" "}
                      {selectedMandate.nach_notify || "N/A"}
                    </div>
                    <div>
                      <strong>Created At:</strong>{" "}
                      {formatDateTime(selectedMandate?.created_date) || "N/A"}
                    </div>
                    <div>
                      <strong>Updated At:</strong>{" "}
                      {formatDateTime(selectedMandate?.updated_date) || "N/A"}
                    </div>
                    <div>
                      <strong>Created By:</strong>{" "}
                      {selectedMandate.created_by || "N/A"}
                    </div>
                    <div style={{ gridColumn: "span 2" }}>
                      <strong>Fail Reason:</strong>{" "}
                      {selectedMandate.failure_reason || "N/A"}
                    </div>
                  </div>
                )}
              </Box>
            </Modal>
          </div>
        )}

        {tabValue === 1 && (
          <div className={mandateModalStyles.tableSection}>
            <table className={mandateModalStyles.customTable}>
              <thead>
                <tr>
                  <th>Mandate ID</th>
                  <th>UMRN</th>
                  <th>Presentation ID</th>
                  <th>Presentation Status</th>
                </tr>
              </thead>

              <tbody style={{ height: "3rem" }}>
                {loanScheduleData?.map((item) => (
                  <tr key={item?.mandate_id}>
                    <td>{item?.mandate_id}</td>
                    <td>{item?.umrn}</td>
                    <td>{item?.presentation_id}</td>
                    <td>{item?.presentation_status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default LoanMandateModal;
